/**
 * Collective object for storing and organizing the render orders for
 * various objects in the viewer.
 */
export const renderOrders = {
  wmsMap: -10,
  /** The replaced orthophoto's overview, under the orthophoto loading in its place. */
  orthoPhotoOverview: -6,
  orthoPhoto: -5,
  compareOrthophotoMesh: 0,
  designAsset: {
    face: 1,
    lineSegment: 100,
    point: 200,
  },
  geometryAsset: {
    mesh: 100,
    line: 200,
  },
  /** Flat drawings (PDF pages) in glb assets, drawn in their own draw order between these. */
  drawing: {
    lines: 10,
    text: 11,
  },
  dxfAsset: {
    surface: 100,
    wireframe: 200,
    line: 300,
    points: 340,
    text: 350,
  },
  aligner: {
    orthoPreview: 0,
    sparseCloud: 1,
    gcpPoints: 300,
    boundaryPolygon: 401, // Neeeds to be higher than the pickers but lower than the gcpLabels.
    gcpLabels: 402, // Needs to be higher than the pickers.
  },
  pickers: {
    pickingLineBackground: 399,
    pickingFace: 400,
    pickingLine: 400,
    pickingSpere: 400,
    // Support lines are drawn below the line being created, the arc, labels and arrow above it.
    angleGuideLine: 399,
    angleGuideLabel: 401,
    inclineGuideOutline: 401,
    inclineGuide: 402,
  },
  referencePlane: 1000,
  referencePointTransformToolPreview: 1100,
  ground: 100000,
  compareOrthophotosDividerLine: 100001,
  /** The CAD drawing report's frame, over everything in the view. */
  reportFrame: {
    mask: 100002,
    outline: 100003,
    handles: 100004,
  },
} as const;
